<script lang="ts">
	import type { DashboardPromoBannerConfig } from 'src/configs/dashboards/energy-dashboard-promo-banners';
	import { profile_data } from 'src/stores/account/user';
	import {
		dashPromoActiveSampleIds,
		dashPromoDismissals,
		dashPromoMaxBanners,
	} from 'src/stores/features/dev/dashboard-promo-samples';
	import { dashPromoEmptyStateEnabled } from 'src/stores/features/dev/dashboard-promo-slots';
	import { verivoxDevForceEnable } from 'src/stores/features/dev/verivox-dev-force-enable';
	import DashPromoGalleryWidget from './DashPromoGalleryWidget.svelte';
	import DashPromoEmptyState from './DashPromoEmptyState.svelte';
	import { mapPromoBannersToSlides } from 'src/components/Promotions/map-promo-banners-to-slides';

	/**
	 * Dashboard `dashPromo` widget adapter.
	 * Resolves banner configs into gallery slides (shared mapper with GlobalInlineBanners).
	 */
	export let banners: DashboardPromoBannerConfig[] = [];

	$: slides = (() => {
		void $profile_data;
		void $verivoxDevForceEnable;
		void $dashPromoActiveSampleIds;
		void $dashPromoDismissals;
		void $dashPromoMaxBanners;
		return mapPromoBannersToSlides(banners, { maxBanners: $dashPromoMaxBanners });
	})();

	$: showEmptyState = slides.length === 0 && $dashPromoEmptyStateEnabled;
</script>

{#if slides.length > 0}
	<DashPromoGalleryWidget {slides} />
{:else if showEmptyState}
	<div class="dash-promo-widget-card__empty">
		<DashPromoEmptyState />
	</div>
{/if}

<style>
	.dash-promo-widget-card__empty {
		width: 100%;
		height: 180px;
		max-height: 180px;
		border-radius: 16px;
		overflow: hidden;
		border: 1px solid rgba(255, 255, 255, 0.12);
		box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
		box-sizing: border-box;
	}
</style>
